import CanVisitMiddleware from '@/middleware/CanVisitMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/courses/:courseId?/activities/:activityId/quiz/:id/:attemptId?',
        component: () => import('@/pages/courses/quizzes/Quiz.vue'),
        props: true,
        children: [
            {
                name: 'quiz-attempt',
                path: '',
                component: () => import('@/components/quiz-attempt/QuizAttempt.vue'),
                meta: {
                    title: 'Quiz',
                    middleWare: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) =>
                        gateKeeper.userHasAccessToCourse(to.params.courseId) &&
                        gateKeeper.userHasPermission('create a quiz attempt'),
                },
            },
        ],
    },

    {
        path: '/courses/:courseId?/activities/:activityId/quiz/:id/:attemptId?/preview',
        component: () => import('@/pages/courses/quizzes/Quiz.vue'),
        props: true,
        children: [
            {
                name: 'quiz-attempt',
                path: '',
                component: () => import('@/components/quiz-attempt/QuizAttempt.vue'),
                meta: {
                    title: 'Quiz',
                    middleWare: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) =>
                        gateKeeper.userHasAccessToCourse(to.params.courseId) &&
                        gateKeeper.userHasAccessToPreviewQuiz(to.params.courseId),
                },
            },
        ],
    },

    {
        path: '/courses/:courseId?/activities/:activityId/quiz/:id',
        component: () => import('@/pages/courses/quizzes/Quiz.vue'),
        props: true,
        children: [
            {
                name: 'quiz-attempt',
                path: '',
                component: () => import('@/components/quiz-attempt/QuizAttempt.vue'),
                meta: {
                    title: 'Quiz',
                    middleWare: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) =>
                        gateKeeper.userHasAccessToCourse(to.params.courseId) &&
                        gateKeeper.userHasPermission('create a quiz attempt'),
                },
            },
        ],
    },
    {
        path: '/courses/:courseId/activities/:activityId/manage-quiz-attempts',
        component: () => import('@/pages/courses/quizzes/QuizAttemptManager.vue'),
        name: 'manage-quiz-attempts',
        meta: {
            title: 'Manage Quiz',
            middleware: [CanVisitMiddleware],
            ability: ({ gateKeeper }) =>
                gateKeeper.userHasGroupPermissionWithinCourse("create another user's quiz attempt") ||
                gateKeeper.userHasPermission("create another user's quiz attempt"),
        },
        props: true,
    },
];
